module.exports = "/_next/static/images/LeverageEvents-f9b37b15fecfc7346528ebc0d7f237c8.webp";